import React from 'react';
import BaseModal, {
	BaseModalProps,
} from '../../../Base/Components/BaseModal/BaseModal';
import WorkplaceProviderCode from './WorkplaceProviderCode';

interface Props extends BaseModalProps {
	workplaceId: string;
}

const WorkplaceProviderCodeModal: React.FC<Props> = props => (
	<BaseModal title='component.workplaceProviderCode.modalTitle' {...props}>
		<WorkplaceProviderCode
			workplaceId={props.workplaceId}
			onSuccess={props.onClose}
		/>
	</BaseModal>
);

export default WorkplaceProviderCodeModal;
